export const superNavItems = [
  {
    name: 'Companies',
    navId: 'companies',
    url: '/company/list',
    icon: 'fal fa-building d-block admin-nav-icon',
    active: 'active-dashboard1',
  },
  {
    name: 'Templates',
    navId: 'templates',
    url: '/settings/templates/appointment/confirmation',
    icon: 'fal fa-copy admin-nav-icon',
    active: 'active-reports1',
  },
  {
    name: 'Users',
    navId: 'users',
    url: '/onboarders/list',
    icon: 'fal fa-user admin-nav-icon',
  },
  {
    name: 'Features',
    navId: 'features',
    url: '/features/tenants-list',
    icon: 'fal fa-flag admin-nav-icon',
  },
];
